"use strict";

var _slicedToArray = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/slicedToArray.js");
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.image = void 0;
var react_1 = __importDefault(require("react"));
var REACT_MARKDOWN_IMAGE_SIZE_REGEX = /_33B2BF251EFD_([0-9]+x|x[0-9]+|[0-9]+x[0-9]+)$/;
function parseImageSizes(src) {
  var match = REACT_MARKDOWN_IMAGE_SIZE_REGEX.exec(src);
  if (!match) {
    return null;
  }
  return match[1].split('x').map(function (s) {
    return s === '' ? undefined : Number(s);
  });
}
function image(_a) {
  var src = _a.src,
    props = __rest(_a, ["src"]);
  var sizes = parseImageSizes(src);
  if (!sizes) {
    return react_1.default.createElement("img", Object.assign({
      src: src
    }, props));
  }
  var _sizes = _slicedToArray(sizes, 2),
    width = _sizes[0],
    height = _sizes[1];
  return react_1.default.createElement("img", Object.assign({
    src: src.replace(REACT_MARKDOWN_IMAGE_SIZE_REGEX, ''),
    width: width,
    height: height
  }, props));
}
exports.image = image;